// Auto generated file, do not manually modify!
// com.hotpads.rentpayment.handler.web.v1.RentCreditReportUnenrollRenterFromCreditTrackingHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

export const RentCreditReportUnenrollRenterFromCreditTrackingHandler_unenrollRenterFromCreditTracking_Path =
  '/api/web/v1/rentCreditReport/unenrollRenterFromCreditTracking';

/**
 * Unenroll renter from credit tracking
 */
export const RentCreditReportUnenrollRenterFromCreditTrackingHandler_unenrollRenterFromCreditTracking = (
  client = getClient(),
) => {
  return httpFrontEndRequest<never, never, void>(
    {
      endpoint: RentCreditReportUnenrollRenterFromCreditTrackingHandler_unenrollRenterFromCreditTracking_Path,
      method: 'POST',
      contextPath: '/rent-payment',
    },
    client,
  );
};
